import ContactUs from "components/category/factCheck/contactUs.js";

export default function Privacy() {
  return <ContactUs />;
}
export async function getServerSideProps(ctx) {
  return {
    props: {}
  };
}